import { NavigationItem, PartnerFragment } from '@amf/shared/types/graphql';
import { ReactNode } from 'react';
import MainLayout from '@amf/shared/components/layout/Layout';
import Navigation from '@amf/shared/components/navigation/Navigation';
import { useTranslate } from '@tolgee/react';
import BrandPlzen from '@amf/shared/icons/brands/BrandPlzen';

import { AppLinks, ExternalLinks } from 'utils/links';
import Footer from 'components/layout/Footer';

interface LayoutProps {
  navigation: NavigationItem[];
  partners: PartnerFragment[];
  children: ReactNode;
}

function Layout({ navigation, partners, children }: LayoutProps) {
  const { t } = useTranslate();
  return (
    <MainLayout footer={<Footer partners={partners} />}>
      <Navigation
        variant='white'
        navigation={navigation}
        search={AppLinks.search}
        brand={<BrandPlzen />}
        buttonTitle={t('navigation.menu.account')}
        buttonLink={ExternalLinks.playerPortal}
        buttonProps={{
          variant: 'dark-outline',
        }}
      />
      {children}
    </MainLayout>
  );
}

export default Layout;
